import { TranslatePipe } from '../../filters/translate.pipe';
import { CardInsurancePoliciesComponent } from '../../components/card-insurance-policies/card-insurance-policies.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'corporate-insurance',
	templateUrl: './corporate-insurance.component.html',
	imports: [ CommonModule, TranslatePipe, CardInsurancePoliciesComponent, FormsModule ]
})
export default class CorporateInsuranceView implements OnInit {
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('corporateInsurance').then(() => {});
	}
	
}